// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c2cbe973","239":"38dfa38d","453":"bed2e23a","455":"6cc14ded","636":"b3665b8b","697":"e7b1c4db","754":"38fcf76d"}[chunkId] + ".chunk.js";
};